import type { OversightAssessmentTestResultsByControlIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetOversightAssessmentTestResultsByControlIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetOversightAssessmentTestResultsByControlIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetOversightAssessmentTestResultsByControlIdArgs = {
  controlId: string;
};

export const useLazyGetOversightAssessmentTestResultsByControlId =
  createLazyQueryHook<
    UseLazyGetOversightAssessmentTestResultsByControlIdArgs,
    OversightAssessmentTestResultsByControlIdResponseRow[],
    GetOversightAssessmentTestResultsByControlIdQuery
  >({
    trpcQuery: (client, { controlId }) =>
      client.frontend.testResult.oversightAssessmentTestResultsByControlId.query(
        { controlId }
      ),
    mapTrpcDataToGraphQL: (data) =>
      ({
        control_test_oversight_result: data,
      }) as unknown as GetOversightAssessmentTestResultsByControlIdQuery,
    graphqlDocument: GetOversightAssessmentTestResultsByControlIdDocument,
    graphqlVariables: ({ controlId }) => ({ controlId }),
  });
